<template>
	<section>
     <el-row>
      <el-col :span="24" >
           
           <div style="background:#C0CCDA;height:30px;line-height:30px;padding-left:5px;margin-top:10px;">角色</div>
           <div style="border: 1px solid #eaeefb;padding:10px;">
              <el-input  placeholder="输入角色进行过滤"  v-model="filterText"></el-input>
              <el-tree  class="filter-tree" style="height:200px;overflow:auto;overflow-x: hidden;margin-top:10px;" 
              :data="roles" :props="rolesProps" @current-change="currentChange"  highlight-current default-expand-all  
              :filter-node-method="filterNode"   ref="roleTree"></el-tree>
           </div>
      </el-col>
   </el-row>
    <el-row>
       <el-col :span="24">
       <div style="background:#C0CCDA;height:30px;line-height:30px;padding-left:5px;margin-top:10px;">功能</div>
       <el-tree  class="filter-tree" style="height:300px;overflow:auto;overflow-x: hidden;" v-loading="fullscreenLoading" 
       :data="rights" :props="rightsProps" node-key="menu_id" show-checkbox  default-expand-all   ref="rightTree"></el-tree>      
       </el-col>
    </el-row>

  <div style="margin-top:10px;">
  <el-button type="primary" @click="saveRoleRight" :loading="saveLoading">提交</el-button>
 
</div>

<el-dialog title="提示" :visible.sync="dialogVisible" top="40%" size="tiny">
  <span>{{dialogContent}}</span>
  <span slot="footer" class="dialog-footer">
    <!--<el-button @click="dialogVisible = false">取 消</el-button> -->
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>


    </section>
 </template>



 <script>

 import { getRightTree,getRoleTree,saveRoleRight,getRoleRight } from '../../api/api';

 let CurrentUserID="",Session=""; 
  export default {
    watch: {
      filterText(val) {
        this.$refs.roleTree.filter(val);
      }
    },

    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.role_name.indexOf(value) !== -1;
      },
      saveRoleRight() {        
        if(this.role_id=='' || this.role_id=='0')
        {
           //this.$message({ message:'请选择用户', type: 'error'});
           this.dialogContent="请选择角色";
           this.dialogVisible=true;         
           return;
        }
       let rights= this.$refs.rightTree.getCheckedNodes(true);
       
      //  if (roles=='')
      //  {
      //      this.dialogContent="请选择角色";
      //      this.dialogVisible=true;
      //      return;
      //  }

this.$confirm('确认提交吗？', '提示', {}).then(() => {
         this.saveLoading=true;
        //this.$http.jsonp(saveRoleRight, {params: {CurrentUserID:CurrentUserID,role_id:this.role_id,rights:JSON.stringify(rights),Session:Session}}).then(
        this.$http.post(saveRoleRight, {CurrentUserID:CurrentUserID,role_id:this.role_id,rights:JSON.stringify(rights),Session:Session},{emulateJSON:false}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							               this.$message({
                                message:'保存成功',
                                type: 'success'
                              });
					                      this.saveLoading=false;                    
                         }
                         else{                           
                             
                               this.saveLoading=false;
                               if (res.data.result_code==911)
                                  {
                                    this.$router.push({ path: "/login"});
                                    return;
                                  }

                              if (res.data.result_code==600)
                              {
                                this.$message({
                                  message:'接口错误',
                                  type: 'error'
                                });
                                return;
                              }
                            if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有保存权限',
                                type: 'error'
                              });
                              return;
                            }
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'保存错误',
                                type: 'error'
                              });
                      this.saveLoading=false;
                   }
           );
      });

     

      },
      currentChange(data,node)
      {       
        this.role_id=data.role_id;
          
        this.$refs.rightTree.setCheckedKeys([]);
        this.fullscreenLoading=true;  
        this.$http.jsonp(getRoleRight, {params: {CurrentUserID:CurrentUserID,role_id:this.role_id,Session:Session}}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {							              
					                  this.$refs.rightTree.setCheckedKeys(res.data.rights);    
                             this.fullscreenLoading=false;                     
                         }
                         else{                           
                              
                              this.fullscreenLoading=false; 

                              if (res.data.result_code==911)
                              {
                                this.$router.push({ path: "/login"});
                                return;
                              }

                              if (res.data.result_code==600)
                              {
                                this.$message({
                                  message:'接口错误',
                                  type: 'error'
                                });
                                return;
                              }
			
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'获取角色权限错误',
                                type: 'error'
                              });
                        this.fullscreenLoading=false;  
                     
                   }
           );

      }

    },
    mounted(){         
                 	CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
                  Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
                 this.$http.jsonp(getRoleTree, {params: {CurrentUserID:CurrentUserID,SysType:3,Session:Session}}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							              this.roles=res.data.roles;
					                                         
                         }
                         else{                           
                              if (res.data.result_code==911)
                              {
                                 this.$router.push({ path: "/login"});
                                return;
                              }

                              if (res.data.result_code==600)
                              {
                                this.$message({
                                  message:'加载角色错误',
                                  type: 'error'
                                });
                                 return;
                              }
					
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'加载角色错误',
                                type: 'error'
                              });
                     
                   }
           );

             this.$http.jsonp(getRightTree, {params: {CurrentUserID:CurrentUserID,Session:Session}}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							              this.rights=res.data.rights;
					                                         
                         }
                         else{                           
                         
                              if (res.data.result_code==911)
                              {
                                  this.$router.push({ path: "/login"});
                                return;
                              }

                              if (res.data.result_code==600)
                              {
                                this.$message({
                                  message:'加载权限错误',
                                  type: 'error'
                                });
                                return;
                              }
                    
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'加载权限错误',
                                type: 'error'
                              });
                     
                   }
           )

    },
    data() {
      return {
        filterText: '',
        role_id:'',
        dialogContent:'',
        dialogVisible:false,
        saveLoading: false,
        fullscreenLoading: false,
        roles: [],
        rolesProps: {
          children: 'children',
          label: 'role_name',
          id:'role_id'
        },
       
        rights: [],
        rightsProps: {
          children: 'children',
          label: 'menu_name',
          id:'menu_id'
        }
      };
    }
  };
</script>


// WEBPACK FOOTER //
// roleright.vue?1d01d478